import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent, SvgIconComponent } from '@woolworthsnz/styleguide';
import { FilterChangeArgs } from '@woolworthsnz/search';

@Component({
	selector: 'search-toggle-filter',
	standalone: true,
	imports: [CommonModule, ButtonComponent, SvgIconComponent],
	templateUrl: './search-toggle-filter.component.html',
	styleUrls: ['./search-toggle-filter.component.scss'],
})
export class SearchToggleFilterComponent {
	@Input() filterOption: FilterChangeArgs;

	@Output() filterToggle = new EventEmitter<FilterChangeArgs>();

	toggleFilter(option: FilterChangeArgs): void {
		const { isSelected } = option;
		this.filterToggle.emit({ ...option, isSelected: !isSelected });
	}
}
